import { render, staticRenderFns } from "./YourApplicationPage.vue?vue&type=template&id=10af3ca9&scoped=true&"
import script from "./YourApplicationPage.vue?vue&type=script&lang=js&"
export * from "./YourApplicationPage.vue?vue&type=script&lang=js&"
import style0 from "./YourApplicationPage.vue?vue&type=style&index=0&id=10af3ca9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af3ca9",
  null
  
)

export default component.exports